/* eslint-disable no-undef */
import 'raf/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import thunk from 'redux-thunk';
import {createStore, applyMiddleware, compose} from 'redux';
import {routerMiddleware} from 'react-router-redux';
import Routes from '../routes';
//import FlashMsg from '../components/app/FlashMsg';
import jreApp from '../reducers/jreApp';
//import {setAuthorizationToken} from '../utilities/api';
import {getCurrentUsers} from '../actions/jre';
import LoadingPage from '../components/app/LoadingPage';
import '../utilities/prototypes';

// analytics-track-start: iframe analytics helper
const ANALYTICS_TARGET_ORIGIN = '*';
const ANALYTICS_MESSAGE_TYPE = 'analytics';
// analytics-track-end

const historyMiddleware = routerMiddleware(history);
const store = createStore(
    jreApp,
    compose(applyMiddleware(thunk, historyMiddleware))
);

window.__synergyStore = store;  // for debugging purpose

class AppRoot extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: null // Null indicates a loading state where the API request has neither succeeded or failed.
        };
        this.serveContent = this.serveContent.bind(this);
        this.handleIframeAnalyticsClick = this.handleIframeAnalyticsClick.bind(this);
    }

    componentDidMount() {
        if (!localStorage.jwtToken) {
            this.setState({isAuthenticated: false});
            return ;
        }
        //setAuthorizationToken(localStorage.jwtToken);
        store.dispatch(getCurrentUsers())
        .then(() => {
            this.setState({isAuthenticated: true});
        })
        .catch(() => {
            this.setState({isAuthenticated: false});
        });
        // console.log('test - 1');
        document.title = 'JRE – JavaScript Rendering Engine 1';
        document.addEventListener('click', this.handleIframeAnalyticsClick);
        this.sendIframeAnalyticsMessage('iframe_page_view', {
            page: window.location.pathname,
            contentType: 'html5'
        });
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleIframeAnalyticsClick);
    }

    // analytics-track-start: send analytics postMessage to parent app
    sendIframeAnalyticsMessage(eventName, props = {}) {
        if (window.parent && window.parent !== window) {
            window.parent.postMessage(
                {
                    type: ANALYTICS_MESSAGE_TYPE,
                    event: eventName,
                    props
                },
                ANALYTICS_TARGET_ORIGIN
            );
        }
    }
    // analytics-track-end

    handleIframeAnalyticsClick(event) {
        const target = event.target;

        if (!target) {
            return;
        }

        const element = target.closest('button, a, input, select, textarea, [data-track]');

        if (!element) {
            return;
        }

        this.sendIframeAnalyticsMessage('iframe_element_clicked', {
            element: element.id || element.className || element.tagName,
            text: element.innerText.trim() || element.value || '',
            page: window.location.pathname
        });
    }

    serveContent() {
        const {isAuthenticated = null} = this.state;

        if (isAuthenticated === null)
        {
            return <LoadingPage />;
        }
        else
        {
            // console.log('serveContent');
            // console.log(history);
            return <Routes history={history} />;
        }
    }

    render() {
        return (
            <Provider store={store}>
            <div id="providerWrapper">
            {this.serveContent()}
            </div>
            </Provider>
        );
    }
}

const initializeCurrentTabCount = () => {
    if (
        localStorage.getItem('currentTabs') === '0' &&
        sessionStorage.getItem('isSameSession') === null
    ) {
        localStorage.clear();
    }
    const currentTabs = parseInt(localStorage.getItem('currentTabs') || 0);
    localStorage.setItem('currentTabs', (currentTabs + 1).toString());
};

const decreaseCurrentTabCount = () => {
    const currentTabs = parseInt(localStorage.getItem('currentTabs') || 0);
    localStorage.setItem('currentTabs', Math.max(currentTabs - 1, 0).toString());
};

window.addEventListener('load', function () {
    initializeCurrentTabCount();
    window.onbeforeunload = decreaseCurrentTabCount;
    sessionStorage.setItem('isSameSession', 'true');
    ReactDOM.render(<AppRoot/>, document.querySelector('.app'));
});

export default store;



// WEBPACK FOOTER //
// ./src/js/app/index.js